import React from "react";

const SalesOfferTemplate = () => {
  const facilities = [
    "Private Swimming Pool",
    "Landscaped Garden",
    "En-suite Bedrooms",
    "Smart Home System",
    "Dedicated Parking",
    "Gated Community",
    "Nearby Schools",
    "24/7 Security",
  ];

  const galleryImages = [
    "https://www.justoffplan.ai//media/properties/images/1u52JeXyDPdyxB0L-1723015327.webp",
    "https://www.justoffplan.ai//media/properties/images/FHzuMtLGIoFCm0l8-1723015324.webp",
    "https://www.justoffplan.ai//media/properties/images/bp9sKhhd824QRtYj-1723015309.webp",
    "https://www.justoffplan.ai//media/properties/images/DevyulGenCNsWqzp-1723015321.webp",
    "https://www.justoffplan.ai//media/properties/images/5dVZNzX04YXqtHeM-1723015332.webp"
  ];

  const paymentSummary = [
    ["Payment Plan", "Yes"],
    ["Post Delivery Payment Plan", "No"],
    ["Min Down Payment %", "10 %"],
    ["Min Down Payment", "2,350,000 AED"],
  ];

  const paymentPlan = [
    ["Booking & 1st Payment", "10%"],
    ["DLD Fees", "4%"],
    ["Within 30 days", "10%"],
    ["Within 5 Months", "5%"],
    ["Within 9 Months", "5%"],
    ["Within 13 Months", "5%"],
    ["Within 17 Months", "5%"],
    ["Within 21 Months", "5%"],
    ["Within 25 Months", "5%"],
    ["On Delivery", "50%"],
  ];

  const units = [
    {
      type: "Villa",
      number: "Villa-10",
      rooms: "5",
      area: "16,948 ft²",
      price: "23,500,000 AED",
    },
  ];


  return (
    <div className="font-sans bg-white text-gray-900">
      {/* Hero Section */}
<section className="min-h-[85vh] relative flex flex-col md:flex-row items-center justify-center px-6 md:px-20 py-16 overflow-hidden break-before-page">
  {/* Background Image as img */}
  <img
    src="https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=6000&q=80"
    alt="Background"
    
    className="absolute inset-0 w-full h-full object-cover z-0"
  />
  {/* Overlay */}
  <div className="absolute inset-0 bg-black/50 z-10"></div>

  {/* Content */}
  <div className="relative z-20 max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12 w-full">
    <div className="text-white max-w-xl text-center md:text-left">
      <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
        NINETEEN RIVIERA LAGOON
      </h1>
      <p className="text-lg mb-4">By Riviera Group</p>
      <span className="inline-block bg-white bg-opacity-20 px-5 py-2 rounded-full text-sm backdrop-blur-md text-black">
  Delivery: December 2026
</span>

    </div>

    <div className="bg-white text-gray-800 shadow-lg rounded-xl p-6 w-full max-w-sm">
      <h2 className="text-xl font-bold mb-1">Nasser Dehghan</h2>
      <p className="text-teal-600 text-sm mb-4">Property Consultant</p>
      <div className="space-y-2 text-sm">
        <p>+971552554245</p>
        <p>Al Khail Real Estate Broker LLC</p>
        <p>alkhail@live.com</p>
      </div>

    </div>
  </div>
</section>


      {/* Location Section */}
       <section className="py-10 px-6 max-w-6xl mx-auto text-center break-before-page">
  <h2 className="text-3xl font-bold mb-6">Location On Map</h2>
  <div className="rounded-xl overflow-hidden shadow-lg">
    <a
      href="https://www.google.com/maps/place/Nad+Al+Sheba,+Dubai"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://maps.googleapis.com/maps/api/staticmap?center=Nad+Al+Sheba,Dubai&zoom=13&size=800x400&maptype=roadmap&markers=color:red%7C25.1762934,55.3485942&key=AIzaSyAjiauCBhyCNq67V07EOW7p7AG45afqk68"
        alt="Map location"
        className="rounded-xl w-full h-90 object-cover"  // 👈 height controlled here
      />
    </a>
  </div>
  <a
    href="https://www.google.com/maps/place/Nad+Al+Sheba,+Dubai"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-4 inline-block px-6 py-2 border border-teal-600 text-teal-600 rounded hover:bg-teal-600 hover:text-white transition"
  >
    Open In Google Map
  </a>
</section>

 <section className="py-20 px-6 max-w-6xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-10 text-center">Property Information</h2>
        <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-md print:shadow-none">
          <table className="w-full text-sm text-left">
            <tbody>
              {[
                ["Project Name", "Soul by Vision"],
                ["Developer Company", "Vision developments"],
                ["City", "Dubai"],
                ["Neighborhood", "Dubai Production City"],
                ["Property Type", "Residential"],
                ["Property Status", "Off Plan"],
                ["Completion Rate", "%"],
                ["No. Of Residential Units", ""],
                ["No. Of Commercial Units", ""],
                ["Marketing Company", ""]
              ].map(([label, value], idx) => (
                <tr
                  key={idx}
                  className={idx % 2 === 0 ? "bg-gray-100" : "bg-gray-300"}
                >
                  <td className="px-6 py-3 font-semibold text-gray-900 border-b border-gray-200 w-1/2">{label}</td>
                  <td className="px-6 py-3 text-gray-800 border-b border-gray-200">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>




      {/* Gallery Section */}
      <section className="bg-gray-50 py-20 px-6 text-center break-before-page">
        <h2 className="text-3xl font-bold mb-10">Property Gallery</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {galleryImages.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Gallery ${idx + 1}`}
              className="w-full h-64 object-cover rounded-xl shadow-md"
            />
          ))}
        </div>
      </section>


      {/* Overview Section */}
      <section className="py-20 px-6 max-w-5xl mx-auto text-left break-before-page">
        <h2 className="text-3xl font-bold mb-8 text-center">Project Overview</h2>
        <div className="space-y-5 text-lg leading-relaxed text-gray-700">
          <p>
            Experience refined living with Nineteen Riviera Lagoon, a distinguished villa community located in Nad Al Sheba. Featuring 5-bedroom luxury villas on expansive plots of 16,948 ft², this project exemplifies elegance, space, and modern architecture.
          </p>
          <p>
            With a 50/50 payment plan, low 10% booking amount, and no post-handover obligations, the project delivers both flexibility and peace of mind for buyers. Close to Downtown Dubai, it’s your premium escape at the city’s edge.
          </p>
        </div>
      </section>

      <section className="py-20 px-6 max-w-6xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-10 text-center text-teal-700">Facilities</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {[
            "Private Swimming Pool",
            "Landscaped Garden",
            "En-suite Bedrooms",
            "Smart Home System",
            "Dedicated Parking",
            "Gated Community",
            "Nearby Schools",
            "24/7 Security"
          ].map((item, index) => (
            <div
              key={index}
              className="px-5 py-3 bg-teal-50 border border-teal-300 text-sm font-medium text-teal-900 rounded-lg shadow-sm text-center"
            >
              {item}
            </div>
          ))}
        </div>
      </section>

  <section className="bg-white py-20 px-6 max-w-6xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-6 text-center">Payments</h2>
        <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-md print:shadow-none">
          <table className="w-full text-sm text-left">
            <tbody>
              {[
                ["Payment Plan", "Yes"],
                ["Post Delivery Payment Plan", "No"],
                ["Min Down Payment %", "10 %"],
                ["Min Down Payment", "2,350,000 AED"]
              ].map(([label, value], idx) => (
                <tr
                  key={idx}
                  className={idx % 2 === 0 ? "bg-gray-100" : "bg-gray-300"}
                >
                  <td className="px-6 py-3 font-semibold text-gray-900 border-b border-gray-200 w-1/2">{label}</td>
                  <td className="px-6 py-3 text-gray-800 border-b border-gray-200">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

     
     {/* Payment Plan */}
      <section className="bg-white py-20 px-6 max-w-6xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-6 text-center">Payment Plan</h2>
        <p className="text-center text-sm text-teal-700 font-semibold mb-4">50 / 50</p>
        <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-md print:shadow-none">
          <table className="w-full text-sm text-left">
            <tbody>
              {[
                ["Booking & 1st Payment", "10%"],
                ["DLD Fees", "4%"],
                ["Within 30 days", "10%"],
                ["Within 5 Months", "5%"],
                ["Within 9 Months", "5%"],
                ["Within 13 Months", "5%"],
                ["Within 17 Months", "5%"],
                ["Within 21 Months", "5%"],
                ["Within 25 Months", "5%"],
                ["On Delivery", "50%"]
              ].map(([label, value], idx) => (
                <tr
                  key={idx}
                  className={idx % 2 === 0 ? "bg-gray-100" : "bg-gray-300"}
                >
                  <td className="px-6 py-3 font-semibold text-gray-900 border-b border-gray-200 w-1/2">{label}</td>
                  <td className="px-6 py-3 text-gray-800 border-b border-gray-200">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Units Section */}
      <section className="py-20 px-6 max-w-6xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-10 text-center">Unit Availability</h2>
        <div className="overflow-x-auto rounded-t border border-gray-200">
          <table className="w-full text-sm">
            <thead className="bg-teal-600 text-white">
              <tr>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Unit No</th>
                <th className="px-4 py-3">Rooms</th>
                <th className="px-4 py-3">Area</th>
                <th className="px-4 py-3">Price</th>
              </tr>
            </thead>
            <tbody>
              {units.map((unit, idx) => (
                <tr key={idx} className="bg-white border-t">
                  <td className="px-4 py-3 font-medium text-gray-800">{unit.type}</td>
                  <td className="px-4 py-3">{unit.number}</td>
                  <td className="px-4 py-3">{unit.rooms}</td>
                  <td className="px-4 py-3">{unit.area}</td>
                  <td className="px-4 py-3 font-semibold text-teal-700">{unit.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

 <section className="py-20 px-6 max-w-5xl mx-auto break-before-page">
        <h2 className="text-3xl font-bold mb-10 text-center">Marketing Material</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-teal-50 border border-teal-300 text-teal-900 font-medium text-sm py-4 px-6 rounded-lg text-center shadow-sm hover:bg-teal-100 transition"
          >
            Floor Plan
          </a>
          <a
            href="https://drive.google.com/file/d/1DXMrV0deFzxWY0WLa0LRALpLmpXujr6U/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-teal-50 border border-teal-300 text-teal-900 font-medium text-sm py-4 px-6 rounded-lg text-center shadow-sm hover:bg-teal-100 transition"
          >
            Project Brochure
          </a>
        </div>
      </section>
    </div>
  );
};

export default SalesOfferTemplate;
